export default __webpack_public_path__ + "static/1870-2000_000-65766b9bec9b6259f642573bcd26269d.jpg";